import { Flame } from "lucide-react";

const ITEMS = [
  "Instalação de gás encanado",
  "Manutenção preventiva",
  "Teste de estanqueidade",
  "Conversão de fogão",
  "Laudos NBR 15526",
  "Atendimento emergencial 24h",
];

export const Marquee = () => (
  <div data-testid="marquee-strip" className="overflow-hidden bg-[var(--primary)] py-3.5">
    <div className="animate-marquee flex w-max items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-lg font-bold uppercase tracking-[0.15em] text-black">
            {item}
          </span>
          <Flame size={18} className="mx-8 text-black/70" fill="currentColor" />
        </span>
      ))}
    </div>
  </div>
);
